// @flow
import * as React from 'react';
import ExperimentsClient from 'app/common/lib/ExperimentsClient';
import PropTypes from 'prop-types';
import type { HocStateless0 } from 'app/common/lib/react/hocTypes';

export type UnauthSeoExperiments = ExperimentsClient;

type WithUnauthSeoExperiments<Props> = HocStateless0<
  Props & { seoUnauthExperiments: ExperimentsClient },
  Props,
  *,
>;

const withUnauthSeoExperiments: WithUnauthSeoExperiments<*> = (Subject) => {
  const UnauthSeoExperiments = function(props, context) {
    return (
      <Subject
        // $FlowIssue: Flow doesn't know Context
        seoUnauthExperiments={context.seoUnauthExperiments}
        {...props}
      />
    );
  };

  UnauthSeoExperiments.contextTypes = {
    seoUnauthExperiments: PropTypes.shape({
      v2GetGroup: PropTypes.func.isRequired,
      v2ActivateExperiment: PropTypes.func.isRequired,
    }).isRequired,
  };

  UnauthSeoExperiments.displayName = `WithUnauthSeoExperiments(${String(
    Subject.displayName || Subject.name,
  )})`;

  return UnauthSeoExperiments;
};

// TODO: this is also defined elsewhere
export const ExperimentsPropType = PropTypes.shape({
  v2GetGroup: PropTypes.func.isRequired,
  v2ActivateExperiment: PropTypes.func.isRequired,
}).isRequired;

export default withUnauthSeoExperiments;
